// src/components/GoogleMap.jsx

import React from 'react';
import { Box, Typography } from '@mui/material';

const GoogleMap = () => {
  return (
    <Box 
      sx={{ 
        width: '100%',
        height: '100%',
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Typography 
        variant="h6" 
        align="center"
        sx={{ 
          my: 1 // Add vertical margin to title
        }}
      >
        Our Location
      </Typography>
      
      {/* Map container with auto bottom margin */}
      <Box
        sx={{
          width: '95%',
          height: 'calc(100% - 60px)', // Reserve space for title
          borderRadius: '8px',
          overflow: 'hidden',
          //border: '1px solid',
          //borderColor: 'divider',
          margin: '0 auto 2.5%', // Top: 0, Horizontal: auto, Bottom: 2.5%
        }}
      >
        <iframe
          title="Google Map Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4041.4474266730604!2d74.34875169916397!3d31.594438068738718!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39191b52fb314ddf%3A0xd4f4d5e4bb9c43e7!2sWhizDot!5e0!3m2!1sen!2s!4v1739482862643!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ 
            border: 0
          }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Box>
    </Box>
  );
};

export default GoogleMap;